import ApplicationSerializer from "./application";
import ENV from "glesys-controlpanel/config/environment";

export default class OrganizationSerializer extends ApplicationSerializer {
  usesProxy = true;

  attrs = {
    isOwner: "isowner",

    identityNumber: "nationalidnumber",
    phone: "phonenumber",
    zip: "zipcode",
    invoiceReference: "invoicereference",
    invoiceDeliveryMethod: "invoicedeliverymethod",
    billingEmailOverrides: "billingemailoverrides",

    separateInvoiceAddress: "separateinvoiceaddress",

    invoiceAddress: "invoiceaddress",
    invoiceZip: "invoicezipcode",
    invoiceCity: "invoicecity",
    invoiceCountry: "invoicecountry",
    paymentTermsNetDays: "paymenttermsnetdays",

    canAccessBilling: "canaccessbilling",

    canPayInvoicesManuallyUsingPaypal: "canpayinvoicesmanuallyusingpaypal",

    hasExpiredInvoices: "expiredinvoices",
    hasUnpaidInvoices: "unpaidinvoices",

    paymentMethod: "paymentmethod",
    availablePaymentMethods: "allowedpaymentmethods",

    paymentCard: "paymentcard",

    currentBillingEmails: "currentbillingemails",
    vatNumber: "vatnumber",

    slaLevel: "slalevel",
    slaPinCode: "slapincode",
    slaPhoneNumber: "slaphonenumber",
    slaCost: "slacost",
    featureFlags: "featureflags",
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.links = {
      projects: `${ENV.apiBaseUri}/customer/listprojects?organizationnumber=${resourceHash.id}`,
      collaborators: `${ENV.apiBaseUri}/customer/listcollaborators?organizationnumber=${resourceHash.id}`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }

  serialize(snapshot, options) {
    let payload = super.serialize(snapshot, options);

    return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== null));
  }
}
